// extracted by mini-css-extract-plugin
export default {"title":"NewProjectPopup_title__r9v0b","iconEdit":"NewProjectPopup_iconEdit__8VtDY","explanation":"NewProjectPopup_explanation__PWiCj"};